import React from "react";
import {useWizard} from "../../hooks/useWizard";
import {ChevronLeftIcon, ChevronRightIcon, XMarkIcon} from "@heroicons/react/20/solid";

export const ModalContainer = ({children}) => {
    return (
        <div className="absolute top-0 left-0 w-screen h-screen bg-gloss flex items-center justify-center z-50">
            {children}
        </div>
    );
};

export const Modal = ({children}) => {
    return (
        <div
            className="bg-white border-solid border-4 border-dark-blue p-5 w-9/12 h-2/3 sm:w-3/5 sm:h-2/3 outline-none">
            {children}
        </div>
    );
};

export const ModalContentContainer = ({children}) => {
    return (
        <div className="flex flex-col pt-12 px-6 pb-6 h-full font-sans sm:justify-between overflow-auto">
            {children}
        </div>
    );
};

export const ModalBody = ({title, children, customStyle}) => {
    return (
        <div
            className={`flex flex-col justify-between ${customStyle} pb-8 text-left`}
            style={{flexGrow: 1}}
        >
            <h1 className="sm:text-4xl font-bold">{title}</h1>
            {children}
        </div>
    );
};

export const ModalSection = ({styles, children}) => {
    return <div className={styles}>{children}</div>;
};

export const ModalFooter = ({
                                currentFormValue,
                                submit,
                                submitButtonLabel = "Next Section",
                                skipButtonLabel = "Skip the questions",
                            }) => {
    const {formValues, setError, next, previous, skip, step} = useWizard();

    return (
        <div className="flex flex-col sm:flex-row sm:justify-between">
            <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                {(step !== 1) && (
                    <button
                        className="flex space-x-2 items-center bg-dark-blue text-white text-sm sm:text-lg font-semibold mt-3 px-5 py-4 rounded"
                        onClick={() => previous()}
                    >
                        <ChevronLeftIcon className="stroke-current stroke-1 h-6 w-6 text-white"/>
                        <span>Previous Section</span>
                    </button>
                )
                }
                <button
                    className="flex space-x-2 items-center bg-dark-blue text-white text-sm sm:text-lg font-semibold mt-3 px-5 py-4 rounded"
                    onClick={() => {
                        if (currentFormValue && !formValues[currentFormValue])
                            return setError(true);

                        if (submit) return submit();

                        next();
                    }}
                >
                    <span>{submitButtonLabel}</span>
                    <ChevronRightIcon className="stroke-current stroke-1 h-6 w-6 text-white"/>
                </button>
            </div>
            <button
                className="flex space-x-2 items-center text-dark-blue text-sm sm:text-xl font-medium mt-3 px-5"
                onClick={skip}
            >
                <span className="border-b border-dark-blue">{skipButtonLabel}</span>
                <XMarkIcon className="stroke-current stroke-1 h-6 w-6 text-dark-blue"/>
            </button>
        </div>
    );
};
